export const setModel = function(model, key ) {
    if (!model[key]) return ''
    return model[key] = model[key].replace(/[() -]/g,'')
}

export const getModel = function(phone) {
    return model[key] = model[key].replace(/[() -]/g,'')
}